import { Offer } from '@App/interfaces/offer';
import TickIcon from '@Components/Icons/TickIcon';
import WarningIcon from '@Components/Icons/WarningIcon';
import {
    RateFeatureType,
    getProductCardFeatureOptions,
} from '@Shared/helpers/productFeatureOptions';
import { IconType } from '@Shared/types';

interface ProductCardFeaturesProps {
    offer: Offer;
    rateFeatureType?: RateFeatureType;
}

export const ProductCardFeatures = ({
    offer,
    rateFeatureType,
}: ProductCardFeaturesProps) => {
    const options = getProductCardFeatureOptions(offer, rateFeatureType);

    return (
        <div className='text-md pb-3'>
            {options.map((item, index) => (
                <div
                    key={index}
                    className='mb-2 flex items-center gap-1 text-sm pl-3 pr-4 py-2 rounded-full bg-almond-500 w-fit'
                >
                    {item.icon === IconType.TICK ? (
                        <TickIcon />
                    ) : (
                        <WarningIcon />
                    )}
                    <span className='ml-1'>{item.label}</span>
                </div>
            ))}
        </div>
    );
};
